<ng-container *transloco="let t; read: 'user'">
@if (user) {
  <div>
    <div class="flex flex-row p-5">
      <h1 class="userProfile font-semibold">{{ t('userProfile.title', { name: (userInfo?.firstName ?? '') + ' ' + (userInfo?.lastName ?? '') }) }}</h1>
      <drdp-btn color="update" routerLink="/update-password">{{ t('userProfile.updatePassword') }}</drdp-btn>
    </div>
    <div class="place-content-center mr-5 ml-2">
      <drdp-container>
        <div class="w-full">
          <div class="flex flex-row justify-between">
            <h1 class="information font-semibold mt-1 flex items-center gap-2">
              <i class="uil uil-user section-icon"></i> {{ t('userProfile.information') }}
            </h1>
            <drdp-btn class="editBtn mt-3" routerLink="/edit-profile">{{ t('userProfile.editProfile') }}</drdp-btn>
          </div>
          <p class="info">
            <span class="font-bold">{{ t('userProfile.name') }}</span> {{ userInfo?.firstName }} {{ userInfo?.middleName }} {{
            userInfo?.lastName }} {{userInfo?.suffix}}
          </p>
          <p class="info"> <span class="font-bold">{{ t('userProfile.workTitle') }}</span> {{ userInfo?.jobTitle }}</p>
          <p class="info"><span class="font-bold">{{ t('userProfile.emailAddress') }}</span> {{ userInfo?.emailName }}</p>

          <hr class="my-4 border-gray-300">

          <h2 class="information font-semibold flex items-center gap-2">
            <i class="uil uil-graduation-cap section-icon"></i> {{ t('userProfile.trainingCertifications') }}
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-2 mt-3">
            <div class="md:pr-5 md:border-r md:border-gray-300">
              <h3 class="font-bold">{{ t('userProfile.completedTrainings') }}</h3>
              @for (training of completedTrainings; track training.id) {
                <span class="pill"
                  [ngClass]="training.id === noTrainingsId ? 'bg-gray-200 text-gray-800' : 'bg-drdpGreen-200 text-drdpGreen-300'">
                  <!-- Server-supplied training name. -->
                  {{ training.trainingName }}
                </span>
              }
            </div>
            <div class="mt-4 md:mt-0 md:pl-5">
              <h3 class="font-bold">{{ t('userProfile.cecoCertification') }}</h3>
              <ng-container *ngTemplateOutlet="yesNoPill; context: { $implicit: userInfo?.isCecoCertified }"></ng-container>
            </div>
          </div>

          <hr class="my-4 border-gray-300">

          <h2 class="information font-semibold flex items-center gap-2">
            <i class="uil uil-users-alt section-icon"></i> {{ t('userProfile.userRoles') }}
          </h2>
          @for (role of user.roleAssignments; track role) {
            <!-- Server-supplied role name. -->
            <span class="pill text-drdpblue-400 bg-drdpblue-500">{{ role.role.roleName }}</span>
          }
          @if (user.roleAssignments.length < 1) {
            <span class="pill text-drdpblue-400 bg-drdpblue-500">{{ t('userProfile.noRoles') }}</span>
          }

          <h2 class="information font-semibold mt-4 flex items-center gap-2">
            <i class="uil uil-globe section-icon"></i> {{ t('userProfile.mySites') }}
          </h2>
          @for (site of user.sites; track site) {
            <!-- Server-supplied site name. -->
            <span class="pill text-drdpPurple-300 bg-drdpPurple-200">{{ site.site.siteName }}</span>
          }
          @if (user.sites.length < 1) {
            <span class="pill text-drdpPurple-300 bg-drdpPurple-200">{{ t('userProfile.noSites') }}</span>
          }

          @if (canEditAgencyData) {
            <hr class="my-4 border-gray-300">

            <h2 class="information font-semibold flex items-center gap-2">
              <i class="uil uil-building section-icon"></i> {{ t('userProfile.agencyData') }}
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-2 mt-3">
              <div class="md:pr-5 md:border-r md:border-gray-300">
                <h3 class="font-bold">{{ t('userProfile.agencyRatingViewsLocked') }}</h3>
                <ng-container *ngTemplateOutlet="yesNoPill; context: { $implicit: userInfo?.isAgencyRatingViewLocked }"></ng-container>
              </div>
              <div class="mt-4 md:mt-0 md:pl-5">
                <h3 class="font-bold">{{ t('userProfile.agencyEulaSubmitted') }}</h3>
                <ng-container *ngTemplateOutlet="yesNoPill; context: { $implicit: userInfo?.isAgencyEulaSubmitted }"></ng-container>
              </div>
            </div>
          }
        </div>
      </drdp-container>
    </div>
  </div>
}

<ng-template #yesNoPill let-value>
  @if (value) {
    <span class="pill bg-drdpGreen-200 text-drdpGreen-300">
      <i class="uil uil-check-circle"></i> {{ t('userProfile.yes') }}
    </span>
  } @else if (value === false) {
    <span class="pill bg-gray-200 text-gray-800">
      <i class="uil uil-times-circle"></i> {{ t('userProfile.no') }}
    </span>
  }
</ng-template>
</ng-container>
